import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import ElevatedButton from '../Layout/ElevatedButton';

const Form = styled.form`
  max-width: 400px;
  margin: ${props => props.compact ? '0.5rem auto' : '2rem auto'};
  padding: ${props => props.compact ? '0.5rem' : '2rem'};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  background: ${props => props.theme.cardBackground};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  color: ${props => props.theme.text};
`;

const Input = styled.input`
  width: 100%;
  padding: ${props => props.compact ? '0.375rem' : '0.75rem'};
  margin: ${props => props.compact ? '0.25rem 0' : '0.5rem 0'};
  border: 1px solid ${props => props.theme.inputBorder};
  border-radius: 4px;
  font-size: 1rem;
  background: ${props => props.theme.inputBackground};
  color: ${props => props.theme.text};
  transition: all 0.2s ease;

  &::placeholder {
    color: ${props => props.theme.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.buttonPrimary};
    background: ${props => props.theme.backgroundSecondary};
    box-shadow: 0 0 0 2px rgba(88, 101, 242, 0.1);
  }
`;

const ProfileForm = ({ compact = false }) => {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Update user logic here
    alert('Profile updated!');
  };

  return (
    <Form compact={compact} onSubmit={handleSubmit}>
      <h2 style={{ color: 'var(--color-primary)', textAlign: 'center', marginBottom: compact ? '0.5rem' : '1rem', fontWeight: 600 }}>Profile</h2>
      <Input
        compact={compact}
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <Input
        compact={compact}
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Input
        compact={compact}
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <ElevatedButton type="submit" style={{ width: '100%', marginTop: compact ? '0.5rem' : '1rem' }}>Update Profile</ElevatedButton>
    </Form>
  );
};

export default ProfileForm;